module.exports = __webpack_public_path__ + "plugins/web/img/小智解读.c7cbff1e.png";